import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

const pitchPaths = new Set(["/"]);

async function renderApp() {
  if (pitchPaths.has(window.location.pathname) || window.location.pathname.startsWith("/pitch/")) {
    const [{ BrowserRouter }, { default: Pitch }] = await Promise.all([
      import("react-router-dom"),
      import("./pages/Pitch.tsx"),
    ]);

    root.render(
      <HelmetProvider>
        <BrowserRouter>
          <Pitch />
        </BrowserRouter>
      </HelmetProvider>,
    );
    return;
  }

  const { default: App } = await import("./App.tsx");
  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>,
  );
}

renderApp().catch((error) => {
  console.error("Failed to mount application", error);
  const rootEl = document.getElementById("root");
  if (rootEl) {
    rootEl.innerHTML = '<main style="min-height:100vh;display:grid;place-items:center;font-family:system-ui,sans-serif;padding:24px"><section style="text-align:center;max-width:420px"><h1 style="margin:0 0 8px;font-size:20px">Unable to load this page</h1><p style="margin:0 0 16px;color:#475569">A network hiccup interrupted loading. Try again.</p><button onclick="location.reload()" style="background:#0f172a;color:#fff;border:0;border-radius:8px;padding:10px 18px;font-size:14px;cursor:pointer">Reload</button></section></main>';
  }
});
